module.exports = __webpack_public_path__ + "img/shop1-3.fee6d9c9.png";